import { render, staticRenderFns } from "./ProjectEnglishNameReadOnlyView.vue?vue&type=template&id=a2450e72&scoped=true&"
import script from "./ProjectEnglishNameReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectEnglishNameReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEnglishNameReadOnlyView.vue?vue&type=style&index=0&id=a2450e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2450e72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VLayout})
